(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oom-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initOomContactReason(root) {
      var radios = root.querySelectorAll('input[name="contact[Reason]"]');
      var venueField = root.querySelector('[data-venue-field]');
      if (!radios.length || !venueField) return;

      function sync() {
        var checked = root.querySelector('input[name="contact[Reason]"]:checked');
        var isWholesale = !!checked && checked.value === 'Stock OOM at my venue';
        venueField.classList.toggle('oom-contact-form__venue-field--hidden', !isWholesale);
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', sync);
      });
      sync();
    }

    document.querySelectorAll('.oom-contact-form__form').forEach(initOomContactReason);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oom-pdp-sticky-cart"]) return;
  try {
    
  class OomPdpStickyCart extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.oom-pdp-sticky-cart__button');
      this.labelEl = this.querySelector('.oom-pdp-sticky-cart__button-label');

      this.realForm = document.querySelector('product-form');
      this.realButton = this.realForm
        ? this.realForm.querySelector('.product-form__submit[name="add"]')
        : null;

      if (!this.realButton) {
        // No real add-to-cart control found on this page — stay hidden
        // rather than offer a button that can't actually do anything.
        this.remove();
        return;
      }

      this.onButtonClick = this.onButtonClick.bind(this);
      this.button.addEventListener('click', this.onButtonClick);

      this.syncFromRealButton();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          this.syncFromRealButton();
        });
      }

      this.observeRealButton();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onButtonClick);
      if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      if (this.observer) this.observer.disconnect();
    }

    syncFromRealButton() {
      if (!this.realButton || !this.button) return;
      this.button.disabled = this.realButton.disabled;
      const realLabel = this.realButton.querySelector('span');
      if (this.labelEl && realLabel) {
        this.labelEl.textContent = realLabel.textContent.trim();
      }
    }

    onButtonClick() {
      if (!this.realButton || this.realButton.disabled) return;
      // Defer entirely to the real form's own submit handling — no
      // second cart request is created here.
      this.realButton.click();
    }

    observeRealButton() {
      const target = this.realForm.closest('.product-form') || this.realForm;
      if (!('IntersectionObserver' in window) || !target) {
        this.classList.add('oom-pdp-sticky-cart--visible');
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          const realButtonVisible = entries[0].isIntersecting;
          this.classList.toggle('oom-pdp-sticky-cart--visible', !realButtonVisible);
        },
        { threshold: 0 }
      );
      this.observer.observe(target);
    }
  }

  if (!customElements.get('oom-pdp-sticky-cart')) {
    customElements.define('oom-pdp-sticky-cart', OomPdpStickyCart);
  }

  } catch(e) { console.error(e); }
})();
})();
